import { render, staticRenderFns } from "./Signalement.vue?vue&type=template&id=4e220023&"
import script from "./Signalement.vue?vue&type=script&lang=js&"
export * from "./Signalement.vue?vue&type=script&lang=js&"
import style0 from "./Signalement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports